import { useState } from 'react';
import { ProfileCard } from '../profile-card/profile-card';
import { useGetAccount } from '../../hooks/use-account';

/** The account settings shown when My Profile has no HR record yet: the profile card alone. */
export const GeneralInfo = () => {
  const { data: userInfo, isLoading } = useGetAccount();
  const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false);

  return (
    <ProfileCard
      userInfo={userInfo}
      isLoading={isLoading}
      onEditClick={() => setIsEditProfileModalOpen(true)}
      isEditProfileModalOpen={isEditProfileModalOpen}
      setIsEditProfileModalOpen={setIsEditProfileModalOpen}
      handleEditProfileClose={() => setIsEditProfileModalOpen(false)}
    />
  );
};
